import { render, staticRenderFns } from "./carbonAccount.vue?vue&type=template&id=1e210c7d&scoped=true&"
import script from "./carbonAccount.vue?vue&type=script&lang=js&"
export * from "./carbonAccount.vue?vue&type=script&lang=js&"
import style0 from "./carbonAccount.vue?vue&type=style&index=0&id=1e210c7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e210c7d",
  null
  
)

export default component.exports